import { CONTEXT_PATH } from '@confluence/named-routes';

export type NavigateToObjectParams = {
	baseUrl: string;
	path: string;
};

export const isSpaTransition = (baseUrl: string): boolean => {
	const host = window.location.host;
	return baseUrl.includes(host) && baseUrl.includes(CONTEXT_PATH);
};

type PushFunction = (path: string) => void;
export const createNavigateToObject =
	(push: PushFunction) =>
	({ baseUrl, path }: NavigateToObjectParams) => {
		if (isSpaTransition(baseUrl)) {
			push(CONTEXT_PATH + path);
		} else {
			window.location.href = `${baseUrl}${path}`;
		}
	};
